import Attention from '@public/next/img/attention.svg';
import classNames from 'classnames';

import styles from './ErrorUserLkShort.module.scss';

export const ErrorUserLkShort = ({ className }) => {
  return (
    <div className={classNames(styles.WrapperError, className)}>
      <Attention width={18} height={18} />
      <div className={styles.Info}>
        <div>Ошибка связи с сервером.</div>
        <div>Пожалуйста, попробуйте снова позже.</div>
      </div>
    </div>
  );
};
